var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusAmount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#8838CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 23.362l13.112 15.01-6.52-15.01H12zm2.887 1.327h2.877l2.846 6.552-5.723-6.552zm17.57-1.328l-6.336 15.01 12.756-14.97h.034l-.021-.04h-6.433zm.836 1.327h2.777l-5.504 6.459 2.727-6.459zm-14.195-1.327l6.52 15.01 6.336-15.01H19.098zm1.98 1.327h8.918L25.6 35.1l-4.523-10.41zm4.442-8.905l-6.426 7.057H31.95l-6.43-7.057zm0 1.934l3.46 3.796h-6.917l3.457-3.797zm9.237-1.934l-2.3 7.057h6.433l-4.133-7.057zm.333 3.126l1.525 2.604h-2.373l.848-2.604zM12 22.84h6.592l-2.459-7.057L12 22.84zm3.836-3.996l.93 2.669h-2.493l1.563-2.669zM16.637 15l2.459 7.058L25.522 15h-8.885zm1.824 1.327h4.091l-2.959 3.25-1.132-3.25zM25.523 15l6.43 7.058 2.3-7.058h-8.73zm2.97 1.327h3.974l-1.047 3.214-2.928-3.214z",
    clipRule: "evenodd"
  })));
}
SvgBonusAmount.displayName = 'BonusAmount';
export default SvgBonusAmount;